(function () {
  const storeTimezone = "America/Los_Angeles";
  const storeTimeOffset = 0;

  function getClockParts() {
    const now = new Date();
    now.setMinutes(now.getMinutes() + storeTimeOffset);

    let timeOptions = {
      timeZone: storeTimezone,
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZoneName: "short"
    };

    let dateOptions = {
      timeZone: storeTimezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    };

    let time;
    let date;

    try {
      time = new Intl.DateTimeFormat("en-US", timeOptions).format(now);
      date = new Intl.DateTimeFormat("en-US", dateOptions).format(now);
    } catch (e) {
      time = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true
      }).format(now);

      date = new Intl.DateTimeFormat("en-US", dateOptions).format(now);
    }

    return {
      time: time.replace(/\s?[A-Z]{2,5}$/, " SV"),
      date: date
    };
  }

  function updateClock() {
    const clock = getClockParts();

    document.querySelectorAll(".date").forEach(function (el) {
      const current = el.textContent.trim();

      if (current !== clock.date) {
        el.textContent = clock.date;
      }
    });

    document.querySelectorAll(".time").forEach(function (el) {
      const current = el.textContent.trim();

      if (current !== clock.time) {
        el.textContent = clock.time;
      }
    });
  }

  function startClock() {
    if (window.kolakClockInterval) {
      clearInterval(window.kolakClockInterval);
    }

    updateClock();

    window.kolakClockInterval = setInterval(function () {
      updateClock();
    }, 30000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startClock, {
      once: true
    });
  } else {
    startClock();
  }
})();